import {
  CurrencySwitcherListItem
} from "./chunk-G3BBAEVO.mjs";

// src/CurrencySwitcherList/CurrencySwitcherList.tsx
import { SimpleGrid, List } from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var CurrencySwitcherList = ({
  listItems,
  listAutoflow = "row",
  onItemClick,
  selectedCurrency: activeItem
}) => /* @__PURE__ */ jsx(List, {
  "data-testid": "currency-switcher-list",
  children: /* @__PURE__ */ jsx(SimpleGrid, {
    columns: { base: 1, md: 3, lg: 3 },
    autoFlow: listAutoflow,
    templateRows: {
      lg: `repeat(${Math.ceil(listItems.length / 3)}, 1fr)`
    },
    spacingX: 5,
    spacingY: 3,
    children: listItems.map((item) => /* @__PURE__ */ jsx(CurrencySwitcherListItem, {
      item,
      onItemClick,
      isActive: activeItem == item.id
    }, item.id))
  })
});

export {
  CurrencySwitcherList
};
